module.exports = __webpack_public_path__ + "img/qr-code-reader.1f734bc6.jpg";